export function FourIcon({ width = 41, height = 61 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 45 59' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_i_1177_1170)'>
        <path
          d='M37.4879 34.232H44.0879V44.968H37.4879V58.96H25.5199V44.968H-7.82955e-05V35.904L7.30392 -4.19044e-05H19.0079L12.3199 34.232H25.5199V12.408H37.4879V34.232Z'
          fill='#F5F7F9'
        />
      </g>
      <defs>
        <filter id='filter0_i_1177_1170' x='0' y='0' width='47.0879' height='58.96' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='3' />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_1177_1170' />
        </filter>
      </defs>
    </svg>
  );
}
